export default {
  // profile: {
  //   en: "Profile",
  //   fr: "Profil"
  // },
  // settings: {
  //   en: "Settings",
  //   fr: "Paramètres"
  // },
  // about: {
  //   en: "About",
  //   fr: "A propos"
  // },
  disconnect: {
    en: "Disconnect",
    fr: "Déconnexion"
  }
};
